import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-meta-column',
  templateUrl: './meta-column.component.html',
  styleUrls: ['./meta-column.component.css']
})
export class MetaColumnComponent implements OnInit {
    metaTableKeyno;

    public metaColumnKeyno: string;

    public edit?: Edit;

    public selectListElementTypes: ElementTypeItem[] = [];

    public itemsListMetaColumns: Item[] = [];

    public saving = false;

    public deleting = false;

    public columnNameTranslatedButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'translateedit', gotoParms: () => this.edit!.colname ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.metaTableKeyno = this.stateService.getStateParams()['metatable_keyno'];
        this.metaColumnKeyno = this.stateService.getStateParams()['metacolumn_keyno'];
    }

    private async loadEdit() {
        if (!!this.metaTableKeyno) {
            this.edit = (await this.datatask.Post(2377, {
                metatable_keyno: this.metaTableKeyno,
                metacolumn_keyno: this.metaColumnKeyno
            }))[0];
        }
    }

    private async loadElementTypes(): Promise<void> {
        this.selectListElementTypes = await this.datatask.Post(2378);
    }

    private async loadMetaColumns(): Promise<void> {
        if (!!this.edit?.metacolumn_keyno) {
            this.itemsListMetaColumns = await this.datatask.Post(3635, { metacolumn_keyno: this.edit?.metacolumn_keyno });
        }
    }

    private async retrieveTranslatedColumnName() {
        if (!!this.edit?.colname) {
            const response = (await this.datatask.Post(2380, { colname: this.edit?.colname }))[0];

            this.edit.colname_translated = response.colname_translated;
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(2379, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(2384, this.edit))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public goToFunc(state: any) {
        switch (state) {
            case 'metacolumnitem':
                this.stateService?.go('metacolumnitem', {
                    metacolumn_keyno: this.edit?.metacolumn_keyno,
                    metacolumnitem_keyno: '0'
                });
                break;
            default:
                break;
        }
    }

    public onBlur(id: string) {
        switch (id) {
            case 'colname':
                if (!!this.edit?.colname) {
                    this.retrieveTranslatedColumnName();
                }
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadElementTypes();
        this.loadMetaColumns();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    metacolumn_keyno: number;
    metatable_keyno: number;
    metatable_name: string;
    colname: string;
    colname_translated: string;
    elementtype: string;
    isrequired: number;
    reg_by: string;
    mod_by: string;
    delete_warning: string;
}

interface ElementTypeItem {
    elementtype: string;
    elementtype_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('metaColumn', {
//        templateUrl: 'views/components/views/metaColumn/metaColumn.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'utilityService', 'metaColumnService', function ($stateParams, stateService, translateService, modalService, utilityService, metaColumnService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let metaTableKeyno = $stateParams.metatable_keyno;
//            let metaColumnKeyno = $stateParams.metacolumn_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                metaColumnKeyno: metaColumnKeyno,
//                colNameTranslatedButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('translateedit', { item_id: vm.model.edit.colname }) }
//                ],
//                edit: {},
//                selectListElementTypes: [],
//                metaColumnItems: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            async function loadEdit() {
//                vm.model.edit = (await metaColumnService.getMetaColumn({
//                    metatable_keyno: metaTableKeyno,
//                    metacolumn_keyno: metaColumnKeyno
//                }))[0];

//                _loadMetaColumnItems();
//            }

//            async function loadElementTypes() {
//                vm.model.selectListElementTypes = await metaColumnService.listElementTypes();
//            }

//            async function _loadMetaColumnItems() {
//                if (vm.model.edit.metacolumn_keyno > 0) {
//                    vm.model.metaColumnItems = await metaColumnService.getMetaColumnItems(vm.model.edit.metacolumn_keyno);
//                }
//            }

//            function retrieveTranslatedColumnName() {
//                if (utilityService.validateParmsValue(vm.model.edit.colname, true) !== true) return;

//                return metaColumnService.getTranslatedColumnName({ colname: vm.model.edit.colname }).then(function (data) {
//                    vm.model.edit.colname_translated = data[0].colname_translated;
//                });
//            }

//            // #endregion LOAD PROCEDURE CALLS

//            // #region ON BLUR MULTI FUNCTIONS

//            vm.onBlur = function (id) {
//                switch (id) {
//                    case 'colname':
//                        if (utilityService.validateParmsValue(vm.model.edit.colname, true) !== true) return;

//                        retrieveTranslatedColumnName();
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion ON BLUR MULTI FUNCTIONS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                metaColumnService.saveObj(vm.model.edit).then((response) => {
//                    if (response[0] && response[0].errorcode !== '0') {
//                        modalService.show({
//                            type: 'warning',
//                            title: translations.error,
//                            message: response[0].errormessage,
//                            buttons: [{
//                                label: translations.ok,
//                                cssClass: 'btn-warning',
//                                action: (dialogItself) => {
//                                    dialogItself.close();
//                                    vm.model.lockedSave = false;
//                                }
//                            }]
//                        });
//                    } else {
//                        vm.model.lockedSave = false;
//                        stateService.back();
//                    }
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: vm.model.edit.delete_warning,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    metaColumnService.deleteObj(vm.model.edit).then((response) => {
//                        if (response[0] && response[0].errorcode !== '0') {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.error,
//                                message: response[0].errormessage,
//                                buttons: [{
//                                    label: translations.ok,
//                                    cssClass: 'btn-warning',
//                                    action: (dialogItself) => {
//                                        dialogItself.close();
//                                        vm.model.lockedDelete = false;
//                                    }
//                                }]
//                            });
//                        } else {
//                            vm.model.lockedDelete = false;
//                            stateService.back();
//                        }
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                translate();
//                loadEdit();
//                loadElementTypes();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
